class LogService {
  error = (...args: any[]) => console.error(new Date(), 'hw/', ...args);

  log = (...args: any[]) => console.log(new Date(), 'hw/', ...args);
}

export default new LogService();
